export enum ReelsViewEvent {
    WIN_ANIMATION_COMPLETE = 'onReelsViewWinAnimationComplete',
}
